import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import saveAs from 'file-saver';
import Arquivo from "model/arquivo/Arquivo";
import { Button } from "primereact/button";
import { FileUpload, FileUploadSelectEvent } from "primereact/fileupload";
import { useState } from "react";
import "./AnexoUnicoPanel.css";
import ModalDocumentoVisualizarArquivo from "components/modal/documentos/ModalDocumentoVisualizarArquivo";
import ModalCriarDocumentoOnline from "components/modal/documentos/ModalCriarDocumentoOnline";
import { confirmDialog } from "primereact/confirmdialog";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";

type Props = {
    novoAnexo: any;
    onChangeNovoAnexo: (anexo: any) => void;
    arquivo: Arquivo | null;
    onChange: (arquivos: Arquivo) => void;
    accept?: string;
    editable?: boolean;
    url?: string;
    idVersao?: number;
    onCreateDocumentoOnline?: (url: string) => void;
    onDeleteDocumentoOnline?: () => void;
    allowDocumentoOnline?: boolean;
}

const documentoVersaoService = new DocumentoVersaoService();
export default function AnexoUnicoPanel(props: Props) {

    const { msgAlerta } = useToastContext();
    const [dragging, setDragging] = useState(false);
    const [documentoVisualizar, setDocumentoVisualizar] = useState<{ visible: boolean, arquivo: Arquivo | null, arquivoLocal: any }>({ visible: false, arquivo: null, arquivoLocal: null });
    const [visibleModalCriarDocumentoOnline, setVisibleModalCriarDocumentoOnline] = useState<boolean>(false);

    function onUploadAnexo(event: FileUploadSelectEvent) {
        try {
            const file = event.files[0];
            if (file) {
                const idAnexo = new Date().getTime() * -1;
                const novoAnexo = { id: idAnexo, nome: file.name, data: null, file };
                props.onChangeNovoAnexo(novoAnexo);
            }
        } catch (error) {
            console.error(error);
        }
    }

    function renderDragAndDropLayout() {
        return <div
            className={dragging ? "drag-drop active" : "drag-drop"}
            onDrop={(e) => {
                setDragging(false)
                e.preventDefault();
                const files = e.dataTransfer.files;
                if (files.length > 0) {
                    onUploadAnexo({ files: Array.from(files) } as FileUploadSelectEvent);
                }
            }}
            onDragEnter={(e) => {
                setDragging(true)
            }}
            onDragLeave={() => {
                setDragging(false)
            }}
            onDragOver={(e) => {
                e.preventDefault()
            }}
        >
            <FontAwesomeIcon icon="file-upload" size={"3x"} />
            <p>Arraste e solte seu arquivo aqui</p>
            <FileUpload
                mode="basic"
                name="anexoscontato"
                accept={props.accept ? props.accept : "*"}
                maxFileSize={52428800}
                multiple={false}
                onSelect={(event) => onUploadAnexo(event)}
                auto={true}
                chooseOptions={{ icon: 'pi pi-upload', label: 'Escolher arquivo', className: "p-button-outlined" }}
                onValidationFail={(e) => msgAlerta("Não foi possível importar", "Tamanho máximo de 50Mb")}
            />
            {props.allowDocumentoOnline !== false ? <>
                <p style={{ margin: 0 }}>ou</p>
                <p style={{ margin: 0, textDecoration: "underline", color: "#0000FF", cursor: "pointer" }} onClick={() => {
                    setVisibleModalCriarDocumentoOnline(true);
                }}>Editar documento online</p>
            </> : null}
        </div>
    }

    function renderOnlineLayout() {
        return (
            <div style={{
                border: '1px solid #dadada', display: "flex", flexDirection: "column",
                borderRadius: 4, boxSizing: "border-box", width: "90%", minHeight: 200, alignItems: "center", justifyContent: "center"
            }}
            >
                <div style={{ marginTop: 8, flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: "space-between", width: "80%", borderRadius: 10, border: '1px solid #dadada' }}>
                    <FontAwesomeIcon icon={props.url?.includes("spreadsheet") ? "file-excel" : "file-word"} size={"2x"} style={{ padding: 10, borderRight: '1px solid #dadada' }} />
                    <span>Documento online</span>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <Button
                            label={"Acessar"} className="p-button-outlined" icon="pi pi-eye"
                            style={{ display: "flex", marginRight: "8px" }}
                            tooltipOptions={{ position: "top" }}
                            onClick={() => { window.open(props.url, '_blank'); }}
                        />
                        {props.editable ? <Button
                            className="p-button-outlined p-button-danger" icon="pi pi-trash"
                            style={{ display: "flex", marginRight: "8px" }}
                            tooltipOptions={{ position: "top" }}
                            tooltip="Excluir Documento Online"
                            onClick={() => {
                                confirmDialog({
                                    message: "Ao deletar esse documento por aqui ele também será deletado do drive?",
                                    header: "Você tem certeza que deseja excluir o documento online?",
                                    icon: "pi pi-exclamation-triangle",
                                    acceptLabel: "Sim",
                                    rejectLabel: "Não",
                                    acceptClassName: "p-button-danger",
                                    accept: () => {
                                        documentoVersaoService.deletarDocumentoOnline(props.idVersao || 0).then(() => {
                                            props.onDeleteDocumentoOnline?.();
                                        }).catch(err => {
                                            msgAlerta("Erro ao deletar documento online", "");
                                        })
                                    }
                                })
                            }}
                        /> : null}
                    </div>

                </div>
            </div>
        )
    }

    function renderDefaultLayout() {
        return (
            <div style={{
                border: '1px solid #dadada', display: "flex", flexDirection: "column",
                borderRadius: 4, boxSizing: "border-box", width: "90%", minHeight: 200, alignItems: "center", justifyContent: "center"
            }}
            >
                {documentoVisualizar.visible ? <ModalDocumentoVisualizarArquivo
                    visible={documentoVisualizar.visible}
                    onHide={() => setDocumentoVisualizar({ visible: false, arquivo: null, arquivoLocal: null })}
                    arquivo={documentoVisualizar.arquivo as Arquivo}
                    arquivoLocal={documentoVisualizar.arquivoLocal}
                /> : null}

                <div style={{ marginTop: 8, flexDirection: 'row', display: 'flex', alignItems: 'center', width: "60%", borderRadius: 10, border: '1px solid #dadada' }}>
                    <FontAwesomeIcon icon="file-pdf" size={"2x"} style={{ padding: 10, borderRight: '1px solid #dadada' }} />
                    {props.novoAnexo ?
                        <span style={{ padding: 10 }}>
                            {props.novoAnexo.nome} {props?.arquivo && props?.arquivo?.id > 0 ? <span style={{ color: 'red' }}>(Alterado)</span> : ""}
                        </span>
                        : <span style={{ padding: 10 }}>
                            {props?.arquivo && props?.arquivo?.id > 0 ? props.arquivo.nome : "Nenhum anexo adicionado"}
                        </span>}

                </div>

                <div style={{ display: 'flex', flexDirection: 'row', width: "60%", columnGap: 8, marginTop: 8 }}>
                    {props.editable ? <FileUpload
                        mode="basic"
                        name="anexoscontato"
                        accept={props.accept ? props.accept : "*"}
                        maxFileSize={52428800}
                        style={{ display: "flex", flex: 3 }}
                        multiple={false}
                        onSelect={(event) => onUploadAnexo(event)}
                        auto={true}
                        chooseOptions={{ icon: 'pi pi-pencil', label: 'Trocar Arquivo', style: { width: '100%' } }}
                        onValidationFail={(e) => msgAlerta("Não foi possível importar", "Tamanho máximo de 50Mb")}
                    /> : null}
                    <Button label={!props.editable ? "Baixar" : ""} className="p-button-outlined" icon="pi pi-download"
                        style={{ display: "flex", flex: 1, boxSizing: "border-box" }}
                        tooltip={props.editable ? "Baixar" : undefined}
                        tooltipOptions={{ position: "top" }}
                        onClick={() => {
                            if (props.novoAnexo && props.novoAnexo.file instanceof File) {
                                saveAs(props.novoAnexo.file, props.novoAnexo.nome)

                            } else {
                                fetch(props?.arquivo?.url || "")
                                    .then(res => res.blob())
                                    .then(blob => saveAs(blob, props?.arquivo?.nome || "arquivo"))
                                    .catch(e => {
                                        console.error(e)
                                    });
                            }
                            return false;
                        }} />
                    <Button
                        label={!props.editable ? "Ver" : ""} className="p-button-outlined" icon="pi pi-eye"
                        style={{ display: "flex", flex: 1, boxSizing: "border-box" }}
                        tooltip={props.editable ? "Ver" : undefined}
                        tooltipOptions={{ position: "top" }}
                        onClick={() => { setDocumentoVisualizar({ visible: true, arquivo: props.arquivo, arquivoLocal: props.novoAnexo }) }}
                    />
                </div>
            </div>
        )
    }

    return <>
        {visibleModalCriarDocumentoOnline ? <ModalCriarDocumentoOnline
            idVersao={props.idVersao || 0}
            visible={visibleModalCriarDocumentoOnline}
            onHide={() => setVisibleModalCriarDocumentoOnline(false)}
            onConfirm={(url) => {
                props.onCreateDocumentoOnline?.(url);
                setVisibleModalCriarDocumentoOnline(false);
            }}
        /> : null}
        {props.url ?
            renderOnlineLayout()
            :
            (!props.arquivo || props.arquivo.id <= 0) && !props.novoAnexo ?
                renderDragAndDropLayout()
                :
                renderDefaultLayout()}
    </>

}


export function getFormData(label: string, data: any, anexo: any, anexoLabel: string = 'files') {
    let formData = new FormData();
    formData.append(label, JSON.stringify(data));

    if (anexo) {
        const file = anexo?.file;
        if (file instanceof File) {
            formData.append(anexoLabel, file);
        } else {
            console.warn(`Anexo não é um File válido:`, file);
        }
    }

    return formData;
}
